export const STANDARD_COVER_LETTER = 'Standard Cover Letter';
export const STANDARD_RESUME = 'Standard Resume';
export const COVER_LETTER_TITLE = 'Cover Letter';
export const COVER_LETTER_SECTION_KEY = 'coverLetter';

export const BLOCK_TYPES = {
  TEXT: 'text',
  BLOCK: 'block',
  ORDERED_LIST: 'ol',
  UNORDERED_LIST: 'ul',
  NUMBER: 'number',
  HEADING: 'heading',
  PARAGRAPH: 'paragraph',
  BULLET_LIST: 'bullet_list',
  LIST_ITEM: 'list_item',
  COMMENT: 'comment',
  HIGHLIGHT: 'highlight',
};

export const DISCLAIMER_TEXT = {
  DISCLAIMER: 'The data used for these tips is protected by copyright',
};

export const infoText =
  'Veteran guidance is currently available only for the "Work Experience" section.';
